<template>
  <div>
    <PreviewAppendix
      :dataContract="dataContract"
      :dataAppendix="dataAppendix"
      :dataConfig="dataConfig"
      :srcPDF="srcPDF"
      canBack
    ></PreviewAppendix>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { ReviewService } from '@/services/review.service'
  import { ContractService } from '@/services/contract.service'
  import PreviewAppendix from '@/pages/contract/component/preview/preview-appendix'

  export default {
    data() {
      return {
        dataContract: {},
        dataAppendix: {},
        dataConfig: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showLoading: true,
        srcPDF: null,
      }
    },

    components: { PreviewAppendix },

    async created() {
      try {
        const query = this.$route.query
        const param = this.$route.params
        const contractId =
          query.contractID ||
          query.contractid ||
          query.contractId ||
          param.contractId ||
          param.contractid ||
          param.contractID
        if (!contractId) {
          alert('Thông tin không hợp lệ , ID hợp đồng không hợp lệ!')
          return
        }
        const response = await ContractService.getDetailContractByID({
          contractId: contractId,
        })
        if (response.code === 1000) {
          this.dataContract = response.data
          if (this.dataContract.typeCustomer && this.dataContract.typeCustomer === 'COMPANY') {
            await this.getLinkPDFBusinessContract()
          }
          await this.getAppendix()
        } else {
          alert('Mã hợp đồng không hợp lệ !')
        }
      } catch (err) {
        alert('Đã có lỗi xảy ra')
        console.log(err)
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async getAppendix() {
        const appendixId = this.$route.params.appendixId
        const dataApendix = await ContractService.getAppendixById({
          appendixId: appendixId,
        })
        if (dataApendix.code !== 1000) {
          throw dataApendix
        }
        this.dataAppendix = dataApendix.data.data
        const typeAppendix = this.dataAppendix.typeAppendix
        this.checkAppendix(typeAppendix)
      },
      async getLinkPDFBusinessContract() {
        try {
          const { appendixId } = this.$route.params
          const body = {
            contractId: '',
            appendixId,
            token: this.dataUser.token,
          }
          const data = await ReviewService.getLinkPDFBusinessContract(body)
          if (data.code === 1000) {
            const start = data.message.indexOf('accessKeyS3=')

            const accessKeyS3 = data.message.substring(start + 12, data.message.length)
            const body = {
              appendixId,
              accessKeyS3: accessKeyS3,
            }
            const dataContractRespon = await ContractService.getLinkPDF(body)
            if (dataContractRespon.success) {
              this.srcPDF = `${dataContractRespon.data.urlContractS3}?key=${accessKeyS3}`
            }
          } else {
            console.log(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      async checkAppendix(typeAppendix) {
        const keyChildMap = {
          CREDIT: 3,
          DEVICE: 4,
          TRANS: 2,
          LIQUIDATE: 6,
          TRANSFER: 7,
          PACKAGE: 5,
          CASHBACK: 8,
          RECALL: 9,
          HAND_OVER: 10,
          QR: 11,
          LEND: 12,
          ONUS: 13,
          CHANGE: 14,
          RENT: 15,
          HOME_PAY_LATER: 16,
          LINK_CARD: 17,
          QR_CONNECTOR: 18,
          NGANLUONG_CONVERT: 19,
        }
        this.dataConfig = {
          keyChild: keyChildMap[typeAppendix] || 0,
          title: Config.typeAppendix.find(s => s.id === typeAppendix).text,
        }
      },
    },
  }
</script>
